//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

/**
 * Enum representing sources of campaigns.
 * Affable: Self-serve campaigns sourced through affable.ai
 * BV: Sampling campaigns sourced through BV platform
 * Influenster: Sampling campaigns sourced through Influenster App
 */
export enum CampaignSource {
  Affable = 'affable',
  BV = 'bv',
  Influenster = 'influenster',
}
